/*
 * BASQUETE MANIA — Confete de recompensa do carrinho.
 * Portado do cpb-confetti.js da XING SUN, com as cores da loja e sem a
 * deteccao por contagem: quem decide a hora e o <oval-cart-progress>, que ja
 * sabe quando a barra CRUZA o beneficio maximo (ver oval-cart-gridiron).
 * Sem dependencia externa — Web Animations API.
 */
(function () {
  if (window.ovalFireConfetti) return;

  var CORES = ['#FF6100', '#FF8F3C', '#171975', '#3B3DB0', '#ffffff', '#ffd54a'];
  var PECAS = 130;

  function fireConfetti() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    // o palco cobre a gaveta do carrinho (fallback: viewport)
    var host = document.querySelector('cart-drawer .drawer__inner')
      || document.querySelector('cart-drawer')
      || document.body;
    var r = host.getBoundingClientRect();
    var top = Math.max(r.top, 0);
    var altura = (r.height && r.height > 0) ? r.height : window.innerHeight;

    var palco = document.createElement('div');
    palco.className = 'ovg-confetti';
    palco.setAttribute('aria-hidden', 'true');
    palco.style.left = r.left + 'px';
    palco.style.top = top + 'px';
    palco.style.width = (r.width || window.innerWidth) + 'px';
    palco.style.height = altura + 'px';
    document.body.appendChild(palco);

    for (var i = 0; i < PECAS; i++) {
      var peca = document.createElement('span');
      peca.className = 'ovg-confetti__peca';
      var tam = 5 + Math.random() * 8;
      peca.style.left = (Math.random() * 100) + '%';
      peca.style.top = (-12 - Math.random() * 60) + 'px';
      peca.style.width = tam + 'px';
      peca.style.height = (tam * (0.45 + Math.random() * 0.55)) + 'px';
      peca.style.background = CORES[(Math.random() * CORES.length) | 0];
      if (Math.random() < 0.4) peca.style.borderRadius = '50%';
      palco.appendChild(peca);

      var dx = (Math.random() * 220) - 110;
      var rot = Math.random() * 360;
      var giro = 360 + Math.random() * 540;
      var dur = 2600 + Math.random() * 1700;
      var atraso = Math.random() * 950;

      peca.animate(
        [
          { transform: 'translate(0, 0) rotate(' + rot + 'deg)', opacity: 1 },
          { transform: 'translate(' + (dx * 0.6) + 'px, ' + (altura * 0.85) + 'px) rotate(' + (rot + giro * 0.8) + 'deg)', opacity: 1, offset: 0.8 },
          { transform: 'translate(' + dx + 'px, ' + (altura + 50) + 'px) rotate(' + (rot + giro) + 'deg)', opacity: 0 }
        ],
        { duration: dur, delay: atraso, easing: 'cubic-bezier(.2,.65,.4,1)', fill: 'forwards' }
      );
    }

    setTimeout(function () {
      if (palco && palco.parentNode) palco.parentNode.removeChild(palco);
    }, 5600);
  }

  window.ovalFireConfetti = fireConfetti;
})();
